<div class="invitation-expired">
    <div class="invitation-expired__image">
        <img src="/assets/images/invitations/invitation-expired.svg" [alt]="'Invitation expiree' | transloco">
    </div>
    <div [ngSwitch]="state" class="invitation-expired__content">
        <div *ngSwitchCase="eInvitation.Account">
            <h3 class="invitation-content__title">{{'Le lien de l\'invitation a malheureusement expire...' | transloco}}</h3>
            <p [innerHTML]="'Le delai pour repondre a l\'invitation a ete depasse, veuillez contacter l\'administrateur de l\'organisation <strong>$name$</strong> afin qu\'il vous genere un nouveau lien d\'invitation.' | transloco:{ name: invitation.account.organization_name | escapeHtml}">
            </p>
        </div>
        <div *ngSwitchCase="eInvitation.Ksuite">
            <h3 class="invitation-content__title">{{'Le lien de l\'invitation a malheureusement expire...' | transloco}}</h3>
            <p [innerHTML]="'Le delai pour repondre a l\'invitation a ete depasse, veuillez contacter l\'administrateur de l\'organisation <strong>$name$</strong> afin qu\'il vous genere un nouveau lien d\'invitation.' | transloco:{ name: invitation.account.organization_name | escapeHtml}">
            </p>
        </div>
        <div *ngSwitchCase="eInvitation.Partner">
            <h3 class="invitation-content__title">{{'Le lien de l\'invitation a malheureusement expire...' | transloco}}
            </h3>
            <p class="invitation-content__text" [innerHTML]="'Le delai pour repondre a l\'invitation a ete depasse, veuillez contacter l\'administrateur de l\'organisation <strong>$name$</strong> afin qu\'il vous genere un nouveau lien d\'invitation.'  | transloco:{ name: invitation.account.organization_name | escapeHtml}">
            </p>
        </div>
        <div *ngSwitchCase="eInvitation.Drive">
            <h3 class="invitation-content__title">{{'Le lien de l\'invitation a malheureusement expire...' | transloco}}</h3>
            <p class="invitation-content__text" 
            [innerHTML]="'Le lien pour rejoindre le <strong>drive $productName$</strong> a expire.' | transloco:{ productName: invitation.extras.drive.name  | escapeHtml} ">
            </p>
            <p class="invitation-content__text">{{'Veuillez contacter l\'administrateur de ce drive afin qu\'il refasse l\'invitation.' | transloco}}</p>
        </div>
        <div *ngSwitchCase="eInvitation.Webmail">
            <h3 class="invitation-content__title">{{'Le lien de l\'invitation a malheureusement expire...' | transloco}}</h3>
            <p class="invitation-content__text"
            [innerHTML]="'Le lien pour utiliser l\'adresse email <strong>$productName$</strong> a expire.' | transloco:{ type: 'drive', productName: this.invitation.extras.webmail.email | escapeHtml } ">
            </p>
            <p class="invitation-content__text">{{'Veuillez contacter l\'administrateur de cette adresse email afin qu\'il refasse l\'invitation.' | transloco}}
            </p>
        </div>
        <div *ngSwitchCase="eInvitation.Transfer">
            <h3 class="invitation-content__title">{{'Le code de transfert a expiree' | transloco}}</h3>
            <p class="invitation-content__text" [innerHTML]="'Le lien pour transferer le produit a expire.' | transloco">
            </p>
            <p class="invitation-content__text">{{'Veuillez contacter l\'administrateur de ce produit afin qu\'il refasse le transfert.' | transloco}}</p>
        </div>
        <div *ngSwitchCase="eInvitation.Password">
            <h3 class="invitation-content__title">{{'Le lien de l\'invitation a malheureusement expire...' | transloco}}</h3>
            <p class="invitation-content__text" [innerHTML]="'Le lien pour modifier le mot de passe a expire.' | transloco">
            </p>
            <p class="invitation-content__text">{{'Veuillez contacter l\'administrateur afin d\'avoir un nouveau lien.' | transloco}}</p>
        </div>
        <div class="invitation-content__actions">
            <a href="https://infomaniak.com"
            mat-flat-button
            color="primary">
             <span>{{ 'Acceder au site infomaniak' | transloco }}</span>
         </a>
        </div>
    </div>
</div>
